import { ICampaignActions, CampaignActions } from "../actions/campaign.action";
import { IPagination } from "../../interfaces/default";
import { offsetToPage } from "../../utils/offsetToPage";
import {
  ICampaignFiltersDto,
  ICampaignSaveResponseDTO,
  ICampaignDetailsDTO,
  ICampaignDTO,
  IAggregateReportDTO,
} from "../../interfaces/dto/campaign.dto";

export interface ICampaignState {
  list: {
    isLoading: boolean;
    data?: Array<ICampaignDTO>;
    error?: string;
    pagination?: IPagination;
    filters?: ICampaignFiltersDto;
  };
  save: {
    isLoading: boolean;
    data?: ICampaignSaveResponseDTO;
    error?: string;
  };
  details: {
    isLoading: boolean;
    data?: ICampaignDetailsDTO;
    error?: string;
  };
  update: {
    isLoading: boolean;
    data?: ICampaignSaveResponseDTO;
    error?: string;
    status?: object;
  };
  trackier: {
    list: {
      isLoading: boolean;
      data?: Array<string>;
      error?: string;
    }, 
    save: {
      isLoading: boolean;
      result?: string;
      error?: string;
    }
  },
  aggregateReport: {
    isLoading: boolean;
    data?: IAggregateReportDTO;
    error?: string;
  };
}

const initialState = {
  list: {
    isLoading: false,
  },
  save: {
    isLoading: false,
  },
  details: {
    isLoading: false,
  },
  update: {
    isLoading: false,
  },
  trackier: {
    list: {
      isLoading: false,
    },
    save: {
      isLoading: false,
    },
  },
  aggregateReport: {
    isLoading: false,
  },
};

export const campaignReducer = (
  state = initialState,
  action: ICampaignActions,
): ICampaignState => {
  switch (action.type) {
    case CampaignActions.GET_AGGREGATE_REPORT:
      return {
        ...state,
        aggregateReport: {
          isLoading: true,
          data: undefined,
          error: undefined,
        },
      };
    case CampaignActions.GET_AGGREGATE_REPORT_SUCCESS:
      return {
        ...state,
        aggregateReport: {
          isLoading: false,
          data: action.payload,
          error: undefined,
        },
      };
    case CampaignActions.GET_AGGREGATE_REPORT_FAILURE:
      return {
        ...state,
        aggregateReport: {
          isLoading: false,
          data: undefined,
          error: action.payload.error,
        },
      };
    case CampaignActions.GET_TRACKIER:
      return {
        ...state,
        trackier: {
          ...state.trackier,
          list: {
            isLoading: true,
            data: undefined,
          },
        },
      };
    case CampaignActions.GET_TRACKIER_SUCCESS:
      return {
        ...state,
        trackier: {
          ...state.trackier,
          list: {
            isLoading: false,
            data: action.payload,
          },
        },
      };
    case CampaignActions.GET_TRACKIER_FAILURE:
      return {
        ...state,
        trackier: {
          ...state.trackier,
          list: {
            isLoading: false,
            data: undefined,
            error: action.payload.error,
          },
        },
      };
    case CampaignActions.SAVE_TRACKIER:
      return {
        ...state,
        trackier: {
          ...state.trackier,
          save: {
            isLoading: true,
            result: undefined,
            error: undefined,
          },
        },
      };
    case CampaignActions.SAVE_TRACKIER_SUCCESS:
      return {
        ...state,
        trackier: {
          ...state.trackier,
          save: {
            isLoading: false,
            result: action.payload,
            error: undefined,
          },
        },
      };
    case CampaignActions.SAVE_TRACKIER_FAILURE:
      return {
        ...state,
        trackier: {
          ...state.trackier,
          save: {
            isLoading: false,
            result: undefined,
            error: action.payload.error,
          },
        },
      };
    case CampaignActions.CAMPAIGN_UPDATE_STATUS:
      return {
        ...state,
        update: {
          isLoading: true,
          error: undefined,
          data: undefined,
          status: undefined,
        },
      };
    case CampaignActions.CAMPAIGN_UPDATE_STATUS_SUCCESS:
      return {
        ...state,
        update: {
          isLoading: false,
          error: undefined,
          data: undefined,
          status: action.payload,
        },
      };
    case CampaignActions.CAMPAIGN_UPDATE_STATUS_FAILURE:
      return {
        ...state,
        update: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
          status: undefined,
        },
      };
    case CampaignActions.CAMPAIGN_UPDATE:
      return {
        ...state,
        update: {
          isLoading: true,
          error: undefined,
          data: undefined,
          status: undefined,
        },
      };
    case CampaignActions.CAMPAIGN_UPDATE_SUCCESS:
      return {
        ...state,
        update: {
          isLoading: false,
          error: undefined,
          data: action.payload,
          status: undefined,
        },
      };
    case CampaignActions.CAMPAIGN_UPDATE_FAILURE:
      return {
        ...state,
        update: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
          status: undefined,
        },
      };
    case CampaignActions.CAMPAIGN_GET_DETAILS:
      return {
        ...state,
        details: {
          isLoading: true,
          error: undefined,
          data: undefined,
        },
      };
    case CampaignActions.CAMPAIGN_GET_DETAILS_SUCCESS:
      return {
        ...state,
        details: {
          isLoading: false,
          error: undefined,
          data: action.payload,
        },
      };
    case CampaignActions.CAMPAIGN_GET_DETAILS_FAILURE:
      return {
        ...state,
        details: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
        },
      };
    case CampaignActions.CAMPAIGN_SAVE:
      return {
        ...state,
        save: {
          isLoading: true,
          error: undefined,
          data: undefined,
        },
      };
    case CampaignActions.CAMPAIGN_SAVE_SUCCESS:
      return {
        ...state,
        save: {
          isLoading: false,
          error: undefined,
          data: action.payload,
        },
      };
    case CampaignActions.CAMPAIGN_SAVE_FAILURE:
      return {
        ...state,
        save: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
        },
      };
    case CampaignActions.CAMPAIGN_GET_LIST_FILTERS:
      return {
        ...state,
        list: {
          ...state.list,
          filters: action.payload,
        },
      };
    case CampaignActions.CAMPAIGN_GET_LIST:
      return {
        ...state,
        list: {
          isLoading: true,
          error: undefined,
          data: undefined,
          pagination: undefined,
        },
      };
    case CampaignActions.CAMPAIGN_GET_LIST_SUCCESS:
      return {
        ...state,
        list: {
          isLoading: false,
          error: undefined,
          data: action.payload.data,
          pagination: {
            ...action.payload.pagination,
            page:
              offsetToPage(
                action.payload.pagination?.offset ?? 0,
                action.payload.pagination?.limit ?? 0,
              ) ?? 1,
          },
        },
      };
    case CampaignActions.CAMPAIGN_GET_LIST_FAILURE:
      return {
        ...state,
        list: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
          pagination: undefined,
        },
      };
    default:
      return state;
  }
};
